import { AccountService } from "src/app/services/account.service";
import { GridsterService } from "src/app/services/gridster.service";
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "src/app/services/api.service";
import { MarketTrades } from "./../../models/company-trades";
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { SignalRService } from "src/app/services/signalr.service";
import {
  MarketWatchDetailService,
  StockDetail,
} from "src/app/services/market-watch-detail.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import * as XLSX from "xlsx";

@Component({
  selector: "app-market-trades",
  templateUrl: "./market-trades.component.html",
  styleUrls: ["./market-trades.component.scss"],
})
export class MarketTradesComponent implements OnInit {
  companyTrades: MarketTrades[];
  isTradesLoading: boolean;

  tradesUpdates = [];
  allMarketNames: StockDetail[];
  isMarket: boolean;
  columns = [];
  isFrozen: boolean = false;
  
  private tradeChangesSubscription: any;
  private namesSubscription: any;


  allFilters = [
    { prop: "EXEC_TIME", name: "time", isChecked: true },
    { prop: "ENG_Name", name: "symbol", isChecked: true },
    { prop: "TRADE_PRICE", name: "price", isChecked: true },
    { prop: "TRADE_VOLUME", name: "qty", isChecked: true },
    { prop: "CHANGE_PRC", name: "change", isChecked: true },
    { prop: "CHANGE", name: "change", isChecked: false },
    { prop: "REUTERS", name: "reuters", isChecked: false },
  ];

  constructor(
    private signalService: SignalRService,
    private _service: ApiService,
    public translate: TranslateService,
    private _marketDetail: MarketWatchDetailService,
    private accService: AccountService,
    private _gridService: GridsterService
  ) {
    this._service.fetchMarketTrades().subscribe((res) => {
      this.isTradesLoading = false;
      this.companyTrades = res as MarketTrades[];
    });
    this.initialize();
    

    this.accService.isFullMarketUser.subscribe((isMarket) => {
      this.isMarket = isMarket;
    });

  }
  @ViewChild("TABLE", { static: false }) table!: ElementRef;

  exportAsExcel() {
    if (!this.table || !this.table.nativeElement) {
      return;
    }

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "TRANSACTIONS");

    // Download the file
    XLSX.writeFile(wb, "transactions.xlsx");
  }

  updateStockDetail(trade: MarketTrades) {
    if (trade && this.allMarketNames) {
      let companyDetail = this.allMarketNames.find(
        (x) => x["SYMBOL_CODE"] === trade.SEC_BORAD_ID
      );
      if (companyDetail) {
        trade.ARB_Name = companyDetail["arb_shortname"];
        trade.ENG_Name = companyDetail["eng_shortname"];
        trade.REUTERS = companyDetail["Reuters"];
      }
    }
  }

  ngOnInit() {
    this.fetchMarketTrades();
  }

  get colsss() {
    return this.columns.filter((col) => col.isChecked);
  }

  fetchMarketTrades() {
    this.isTradesLoading = true;

    this._service.fetchMarketTrades().subscribe((res) => {
      this.isTradesLoading = false;
      this.companyTrades = res as MarketTrades[];
    });
  }

  toggle(col, event) {
    col.isChecked = !col.isChecked;

    this.updateCols();
  }

  updateCols() {
    this._gridService.saveTradesColumns(this.columns);
    this.WindowResize();
  }

  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 50);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    this.updateCols();
  }

  toggleFrozen() {
    this.isFrozen = !this.isFrozen;

    // Clean up subscriptions before re-initializing
    this.cleanupSubscriptions();

    // Reinitialize based on the updated isFrozen value
    this.initialize();

    setInterval(() => {
      this.isFrozen = false;
      // Toggle the boolean
    }, 15000); // 10000ms = 10 seconds
  }

  cleanupSubscriptions() {
    // Unsubscribe from the SignalR and Market Watch name updates when the component is destroyed
    if (this.tradeChangesSubscription) {
      this.tradeChangesSubscription.unsubscribe();
    }
    if (this.namesSubscription) {
      this.namesSubscription.unsubscribe();
    }
  }

  initialize() {
    if (!this.isFrozen) {
      // Subscribe to trade updates
      this.tradeChangesSubscription = this.signalService.tradeChanges.subscribe((res) => {
        if (this.allMarketNames) {
          res.reverse();
          res.forEach((trade) => {
            if (this.companyTrades) {
              this.updateStockDetail(trade);
              this.companyTrades.unshift(trade);
            }
          });
          // Limit the trade count to 100
          if (this.companyTrades?.length > 100) {
            this.companyTrades.length = 100;
          }
        }
      });
    }

    // Subscribe to market name updates
    if (this._marketDetail.marketNames) {
      this.allMarketNames = this._marketDetail.marketNames.getValue();
    }

    this.namesSubscription = this._marketDetail.namesSubject.subscribe((res) => {
      this.allMarketNames = res as StockDetail[];
    });
  }


  
  ngOnDestroy() {
    // Cleanup subscriptions on component destruction
    this.cleanupSubscriptions();
  }
}
